import { render, staticRenderFns } from "./pc-dropdown.vue?vue&type=template&id=18bb5b63&"
import script from "./pc-dropdown.vue?vue&type=script&lang=ts&"
export * from "./pc-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./pc-dropdown.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports